import { useReducer } from 'react';
import CartContext from './cart-context';
import cartReducer from './cartReducer';

export const defaultCartState = {
  items: [],
  totalAmount: 0,
  showFooter: true,
};

const CartProvider = ({ children }) => {
  // Used as a wrapper component to provide state access to children
  const [cartState, dispatchCart] = useReducer(cartReducer, defaultCartState);

  // Actions Dispatch to the Reducer
  const onAddCartItem = (item) => {
    dispatchCart({ type: 'ADD_ITEM', payload: item });
  };

  const onRemoveCartItem = (id) => {
    dispatchCart({ type: 'REMOVE_ITEM', payload: id });
  };

  const onClearCart = () => {
    dispatchCart({ type: 'CLEAR' });
  };

  const onSetShowFooter = (show) => {
    dispatchCart({ type: 'SHOW_FOOTER', payload: show });
  }

  // default cart context
  const cartContext = {
    items: cartState.items,
    totalAmount: cartState.totalAmount,
    showFooter: cartState.showFooter,
    addItem: onAddCartItem,
    removeItem: onRemoveCartItem,
    clear: onClearCart,
    setShowFooter: onSetShowFooter
  };

  return (
    <CartContext.Provider value={cartContext}>{children}</CartContext.Provider>
  );
};

export default CartProvider;
